/* AMC rack, cantilever, vault, cooler and embalming-station add-on picker. Add-ons submit as separate native cart lines.
   2026-11-01: lift cards toggle on/off (no visible "No lift" tile); lift price is not shown on the page and is not
   folded into the package total ("priced in cart"); the integrated scale is offered in the cart flyout. */
(() => {
  'use strict';
  if (window.__amcRackAddons) return;
  window.__amcRackAddons = true;
  const fmt = c => new Intl.NumberFormat('en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD', minimumFractionDigits: c % 100 ? 2 : 0 }).format(c / 100);
  const boxes = new WeakMap();
  let cartRacks = null;
  let cartPromise = null;

  function loadCart(handles) {
    if (cartPromise) return cartPromise;
    cartPromise = fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(r => r.json())
      .then(c => { cartRacks = (c.items || []).filter(i => handles.includes(i.handle)).reduce((n, i) => n + i.quantity, 0); })
      .catch(() => { cartRacks = 0; });
    return cartPromise;
  }

  function init() {
    document.querySelectorAll('[data-amc-rack-addons]').forEach(box => {
      if (boxes.has(box)) return;
      const cfgEl = box.querySelector('[data-rr-config]');
      if (!cfgEl) return;
      let cfg;
      try { cfg = JSON.parse(cfgEl.textContent); } catch (_) { return; }
      const form = box.closest('form');
      const root = box.closest('product-info') || document;
      const isRack = cfg.mode === 'rack' || cfg.mode === 'cantilever';
      const liftInCart = cfg.liftPriceInCart !== false;
      const key = 'amc-rr:' + box.dataset.product;
      let saved = {};
      try { saved = JSON.parse(sessionStorage.getItem(key) || '{}'); } catch (_) {}
      const st = { qty: saved.qty || 1, items: saved.items || {}, lift: saved.lift || '', scale: false, valid: true };
      boxes.set(box, { st, cfg, box, update: null });

      const $ = s => box.querySelector(s);
      const qtyIn = $('[data-rr-qty]');
      const cards = [...box.querySelectorAll('[data-rr-item]')];
      const lifts = [...box.querySelectorAll('input[type=radio][name^="rr-lift-"]')];
      const noneLift = lifts.find(l => l.value === '');
      const realLifts = lifts.filter(l => l.value !== '');
      if (st.lift && !realLifts.some(l => l.value === st.lift)) { st.lift = ''; }
      const scale = $('[data-rr-scale]');
      const nativeQty = () => [...root.querySelectorAll('input[name=quantity]:not([type=hidden])')];
      const liftName = l => l?.closest('label')?.querySelector('.amc-rr__lift-t')?.textContent.trim() || 'lift';

      const baseCents = () => {
        const id = form?.querySelector('[name=id]')?.value;
        const v = cfg.variants[id];
        if (typeof v === 'number') return v;
        const vals = Object.values(cfg.variants);
        return vals.length ? vals[0] : 0;
      };
      const tierFor = n => cfg.tiers.reduce((off, [at, c]) => (n >= at ? c : off), 0);
      const nextTier = n => cfg.tiers.find(([at]) => n < at);

      function syncNative() {
        if (!isRack) return;
        nativeQty().forEach(i => {
          const w = i.closest('quantity-input') || i.parentElement;
          if (w && !box.contains(w)) { w.style.display = 'none'; w.setAttribute('aria-hidden', 'true'); }
          i.max = String(cfg.maxQty);
          i.dataset.max = String(cfg.maxQty);
          if (String(i.value) !== String(st.qty)) { i.value = String(st.qty); }
        });
      }

      function update() {
        if (!box.isConnected) return;
        const base = baseCents();
        let qty = 1;
        if (isRack) {
          st.qty = Math.max(1, Math.min(cfg.maxQty, parseInt(st.qty, 10) || 1));
          qty = st.qty;
          if (document.activeElement !== qtyIn) qtyIn.value = String(qty);
          syncNative();
        } else {
          qty = Math.max(1, parseInt(nativeQty()[0]?.value || '1', 10) || 1);
        }
        let list = base * qty, total = list, save = 0;

        if (isRack) {
          const inCart = cartRacks || 0;
          const count = qty + inCart;
          const off = Math.min(tierFor(count), base);
          save = off * qty;
          total = list - save;
          $('[data-rr-each]').textContent = fmt(base - off) + ' per rack';
          $('[data-rr-was]').textContent = off ? fmt(base) + ' list' : '';
          $('[data-rr-tiername]').textContent = off ? 'Saving ' + fmt(off) + ' per rack' : 'List price';
          $('[data-rr-tiername]').classList.toggle('is-save', !!off);
          const stops = [1, ...cfg.tiers.map(t => t[0])];
          let idx = 0;
          stops.forEach((s, i) => { if (count >= s) idx = i; });
          box.querySelectorAll('.amc-rr__ladder li').forEach((li, i) => {
            li.classList.toggle('is-done', i <= idx);
            li.classList.toggle('is-now', i === idx);
          });
          const nxt = nextTier(count);
          let pct = (idx / (stops.length - 1)) * 100;
          if (nxt) {
            const a = stops[idx], b = nxt[0];
            pct += ((count - a) / (b - a)) * (100 / (stops.length - 1));
          }
          $('[data-rr-fill]').style.width = Math.min(100, pct) + '%';
          const msg = [];
          if (save) msg.push(`<strong>You save ${fmt(save)}</strong> on ${qty} rack${qty > 1 ? 's' : ''}.`);
          if (nxt) {
            const more = nxt[0] - count;
            const gain = Math.min(nxt[1], base) - off;
            msg.push(`Add ${more} more rack${more > 1 ? 's' : ''} and every rack drops another ${fmt(gain)}.`);
          } else {
            msg.push('Top bulk price unlocked: ' + fmt(Math.min(cfg.tiers[cfg.tiers.length - 1][1], base)) + ' off every rack.');
          }
          if (inCart) msg.push(`Includes ${inCart} rack${inCart > 1 ? 's' : ''} already in your cart.`);
          $('[data-rr-save]').innerHTML = msg.join(' ');
          const bulk = $('[data-rr-bulk]');
          if (bulk) bulk.href = '/pages/bulk-rack-pricing?pre=' + encodeURIComponent(cfg.handle) + '*' + qty;
        }

        // add-ons
        let addons = 0;
        cards.forEach(c => {
          const k = c.dataset.rrItem;
          const n = st.items[k] || 0;
          c.querySelector('[data-rr-n]').textContent = String(n);
          c.classList.toggle('is-on', n > 0);
          const capHit = n >= 999;
          c.querySelector('[data-rr-inc]').disabled = capHit;
          c.querySelector('[data-rr-dec]').disabled = n <= 0;
          addons += n * Number(c.dataset.price);
        });
        const liftInput = realLifts.find(l => l.value === st.lift) || null;
        if (!liftInput) st.lift = '';
        lifts.forEach(l => {
          l.checked = liftInput ? l === liftInput : l === noneLift;
          const lab = l.closest('label'); if (!lab) return;
          const on = !!liftInput && l === liftInput;
          lab.classList.toggle('is-on', on);
          const txt = lab.querySelector('.amc-rr__lift-plus-txt'); if (txt) txt.textContent = on ? 'Added' : 'Add';
          const pr = lab.querySelector('[data-rr-liftprice]'); if (pr) pr.textContent = on ? 'Added to cart with this order' : 'Price shown in cart';
          lab.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        const sw = $('[data-rr-scalewrap]'), note = $('[data-rr-liftnote]'), ll = $('[data-rr-liftline]');
        if (sw) sw.hidden = true;
        if (liftInput) {
          if (!liftInCart) addons += Number(liftInput.dataset.noPrice);
          if (ll) { ll.hidden = false; ll.innerHTML = '<span class="amc-rr__sum-check" aria-hidden="true">✓</span> ' + liftName(liftInput) + ' added · priced in cart'; }
          if (note) {
            note.hidden = false;
            note.innerHTML = st.lift === 'lpl'
              ? '<b>Low Profile Mortuary Lift:</b> lowers to 13″, the lowest deck of any AMC lift. Add the integrated scale in your cart if you want it.'
              : '<b>Loading height notice:</b> the manual scissor lift’s 20.5″ lowest deck does not reach the lower tiers of most racks. Only the Low Profile Lift is built for low-tier loading. Measure every tier you need to reach; we are not responsible for ordering errors.';
          }
        } else {
          if (ll) ll.hidden = true;
          if (note) note.hidden = true;
        }
        total += addons;
        list += addons;
        $('[data-rr-total]').textContent = fmt(total);
        $('[data-rr-sumlabel]').textContent = addons || qty > 1 || liftInput ? (liftInput && liftInCart ? 'Package total before lift' : 'Package total') : 'Total';
        const ts = $('[data-rr-totalsave]');
        ts.hidden = !save;
        if (save) ts.innerHTML = `List ${fmt(list)} &middot; <strong>bulk savings ${fmt(save)}</strong>, applied in cart`;
        const hasExtras = addons > 0 || !!liftInput;
        root.querySelectorAll('.shopify-payment-button').forEach(el => { el.hidden = hasExtras || (isRack && qty > 1); });
        $('[data-rr-cartnote]').hidden = !hasExtras;
        $('[data-rr-cartnote]').textContent = hasExtras ? (cfg.mode === 'station' ? 'Tables go to your cart as separate lines with the station.' : cfg.mode === 'cooler' || cfg.mode === 'vault' ? 'Add-ons go to your cart as separate lines with the cooler.' : 'Add-ons go to your cart as separate lines with the rack.') + ' Shipping is calculated at checkout.' : '';
        try { sessionStorage.setItem(key, JSON.stringify({ qty: st.qty, items: st.items, lift: st.lift })); } catch (_) {}
      }
      boxes.get(box).update = update;

      if (isRack) {
        $('[data-rr-minus]').addEventListener('click', () => { st.qty = (st.qty || 1) - 1; update(); });
        $('[data-rr-plus]').addEventListener('click', () => { st.qty = (st.qty || 1) + 1; update(); });
        qtyIn.addEventListener('input', () => { const n = parseInt(qtyIn.value, 10); if (n) { st.qty = n; update(); } });
        qtyIn.addEventListener('change', () => { st.qty = parseInt(qtyIn.value, 10) || 1; update(); });
        box.querySelectorAll('[data-rr-set]').forEach(b => b.addEventListener('click', () => { st.qty = Number(b.dataset.rrSet); update(); }));
        root.addEventListener('change', e => { if (e.target.name === 'quantity' && !box.contains(e.target)) { st.qty = parseInt(e.target.value, 10) || 1; update(); } });
        root.addEventListener('click', e => { if (e.target.closest?.('.quantity__button') && !box.contains(e.target)) setTimeout(() => { const n = parseInt(nativeQty()[0]?.value, 10); if (n) { st.qty = n; update(); } }, 30); });
      } else {
        root.addEventListener('change', e => { if (e.target.name === 'quantity') update(); });
      }
      cards.forEach(c => {
        const k = c.dataset.rrItem;
        c.querySelector('[data-rr-inc]').addEventListener('click', () => { st.items[k] = (st.items[k] || 0) + 1; update(); });
        c.querySelector('[data-rr-dec]').addEventListener('click', () => { st.items[k] = Math.max(0, (st.items[k] || 0) - 1); update(); });
      });
      // Lift cards toggle: click a selected card (or its Add control) to remove it; click another to switch.
      realLifts.forEach(l => {
        const lab = l.closest('label');
        lab?.addEventListener('click', e => {
          e.preventDefault();
          const on = st.lift !== l.value;
          st.lift = on ? l.value : '';
          update();
          (on ? l : noneLift)?.dispatchEvent(new Event('change', { bubbles: true }));
        });
        l.addEventListener('keydown', e => { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); lab?.click(); } });
      });
      // External toggles (Pairs-with plus, manual-row button) dispatch change on the radio they set.
      lifts.forEach(l => l.addEventListener('change', () => { if (l.checked && st.lift !== l.value) { st.lift = l.value; update(); } }));
      scale?.addEventListener('change', () => { update(); });
      if (form) form.addEventListener('change', e => { if (e.target.name === 'id') update(); });
      const idInput = form?.querySelector('[name=id]');
      if (idInput && typeof MutationObserver !== 'undefined') new MutationObserver(update).observe(idInput, { attributes: true, attributeFilter: ['value'] });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(update, 0));
      update();
      if (isRack) loadCart(cfg.rackHandles).then(update);
    });
  }

  // Called by product-form.js inside the native add-to-cart request.
  window.amcRackAddonsAppend = (form, data) => {
    const box = form.querySelector('[data-amc-rack-addons]');
    const inst = box && boxes.get(box);
    if (!inst) return;
    inst.update();
    const { st, cfg } = inst;
    const isRack = cfg.mode === 'rack' || cfg.mode === 'cantilever';
    const extra = [];
    box.querySelectorAll('[data-rr-item]').forEach(c => {
      const n = st.items[c.dataset.rrItem] || 0;
      if (n > 0) extra.push({ id: c.dataset.id, quantity: n });
    });
    if (st.lift) {
      const l = box.querySelector(`input[type=radio][value="${st.lift}"]`);
      if (l) extra.push({ id: l.dataset.no, quantity: 1 });
    }
    const usesItems = data.has('items[0][id]');
    if (isRack) {
      if (usesItems) data.set('items[0][quantity]', String(st.qty)); else data.set('quantity', String(st.qty));
    }
    if (!extra.length) return;
    if (!usesItems) {
      const baseId = data.get('id'), quantity = data.get('quantity') || '1';
      data.delete('id'); data.delete('quantity');
      data.set('items[0][id]', baseId); data.set('items[0][quantity]', quantity);
      for (const [k, v] of [...data.entries()]) {
        if (/^properties\[/.test(k)) { data.delete(k); data.append(`items[0][${k.replace('[', '][')}`, v); }
        if (k === 'selling_plan') { data.delete(k); data.set('items[0][selling_plan]', v); }
      }
    }
    let i = 0;
    while (data.has(`items[${i}][id]`)) i++;
    extra.forEach(x => { data.set(`items[${i}][id]`, String(x.id)); data.set(`items[${i}][quantity]`, String(x.quantity)); i++; });
    inst.pending = true;
    try { sessionStorage.removeItem('amc-rr:' + box.dataset.product); } catch (_) {}
  };

  // After a confirmed add, clear the add-on picks so a second click does not double them.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      document.querySelectorAll('[data-amc-rack-addons]').forEach(box => {
        const inst = boxes.get(box);
        if (!inst?.pending) return;
        inst.pending = false;
        inst.st.items = {}; inst.st.lift = ''; inst.st.qty = 1;
        cartPromise = null;
        loadCart(inst.cfg.rackHandles).then(() => inst.update && inst.update());
      });
    });
  }

  init();
  let queued = false;
  new MutationObserver(() => { if (!queued) { queued = true; queueMicrotask(() => { queued = false; init(); }); } })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
